<template>
  <div class="awareness-banner">
    <div class="awareness-banner__image-container">
      <img v-if="image" class="awareness-banner__image" :src="image" />
    </div>

    <div class="awareness-banner__main-column">
      <h2>{{ title }}</h2>

      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AwarenessBanner",
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss">
@import "~bootstrap/scss/mixins/breakpoints";

.awareness-banner {
  display: grid;
  grid-template-columns: 14rem 1fr;
  border-radius: 0.5rem;
  align-items: start;
  justify-content: center;
  gap: 1rem;

  @include media-breakpoint-down(md) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    padding: 0;
  }

  h2 {
    font-size: 1.25rem;
    font-weight: bold;
    text-align: center;
  }

  &__image-container {
    width: 100%;
    padding-top: 2rem;

    @include media-breakpoint-down(md) {
      padding: 0;
    }
  }
  &__image {
    border-radius: 50%;
    object-fit: cover;
    width: 100%;
    max-width: 12rem;
    margin: 0 auto;
    display: block;
    aspect-ratio: 1 / 1;
  }

  &__main-column {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
